/**
 * Get most recent safeguards from items array
 * @param {Array} items - Array of items to process
 * @returns {Array} - Most recent safeguards
 */
function getMostRecentSafeguards(items) {
	const safeguardMap = items.reduce((acc, item) => {
		const safeguardId = item.safeguardid.S;
		const timestamp = parseInt(item.timestamp, 10); // Use the pre-extracted timestamp
		
		// Keep only the most recent item for each safeguardId
		if (!acc[safeguardId] || acc[safeguardId].timestamp < timestamp) {
			acc[safeguardId] = item;
		}
		
		return acc;
	}, {});
	
	console.log("Most recent safeguards: ", safeguardMap);
	
	return Object.values(safeguardMap);
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
	module.exports = getMostRecentSafeguards;
} else if (typeof window !== 'undefined') {
	window.getMostRecentSafeguards = getMostRecentSafeguards;
}
